<div class="container">
  <span class="title">
    {{title}}
  </span>
  <div *ngIf="statusType === StatusType.GeneralError"
       class="status status--error"
       [matTooltip]="'An error occurred while saving the draft. ' + contactString">
    <mat-icon class="material-icons-round warning-icon">warning</mat-icon>
    Unable to save. See details.
  </div>
  <div *ngIf="statusType === StatusType.MissingCompanyNameError"
       class="status status--error"
       matTooltip="A company name is required in order to save a draft and upload documents.">
    <mat-icon class="material-icons-round warning-icon">warning</mat-icon>
    Unable to save. See details.
  </div>
  <span *ngIf="statusType === StatusType.InProgress"
        class="status status--in-progress">
    Saving...
  </span>
  <div *ngIf="statusType === StatusType.Success"
       class="status status--success">
    <mat-icon class="success-icon">check</mat-icon>
    Auto-saved
  </div>
</div>
